import React from 'react';
import { GENERAL_INSTRUCTIONS, SECTION_TITLES, sectionMarks } from './aiPaperUtils';
import { SHEET_CSS } from './sheetStyles';

const Bi = ({ en, hi, mode }) => (
  <>
    {mode !== 'hindi' && en ? <div className="aip-en">{en}</div> : null}
    {mode !== 'english' && hi ? <div className="aip-hi">{hi}</div> : null}
  </>
);

const Options = ({ q, mode }) => (
  <div className="aip-opts">
    {q.options.map((o) => (
      <div key={o.label}>
        <b>({o.label})</b>{' '}
        {mode !== 'hindi' && o.textEnglish}
        {mode === 'bilingual' && o.textEnglish && o.textHindi ? ' / ' : ''}
        {mode !== 'english' && o.textHindi}
      </div>
    ))}
  </div>
);

const AnswerBlock = ({ q }) => (
  <>
    <div className="aip-ans">
      <b>Answer: </b>{q.correctAnswer || '—'}
      {q.modelAnswer ? <div style={{ marginTop: 3 }}><b>Marking scheme:</b>{'\n'}{q.modelAnswer}</div> : null}
    </div>
    {q.pageRef ? <div className="aip-ref">Source: textbook page {q.pageRef}</div> : null}
  </>
);

const Question = ({ q, no, mode, isKey }) => (
  <div className="aip-q">
    <div className="aip-qn">{no}.</div>
    <div className="aip-qb">
      <Bi en={q.textEnglish} hi={q.textHindi} mode={mode} />
      {q.type === 'MCQ' && q.options?.length ? <Options q={q} mode={mode} /> : null}
      {isKey ? <AnswerBlock q={q} /> : null}
    </div>
    <div className="aip-qm">[{q.marks}]</div>
  </div>
);

const Header = ({ paper, isKey, logoSrc }) => (
  <div className="aip-block">
    <div className="aip-head">
      <div className="aip-head-row">
        {logoSrc ? <img src={logoSrc} alt="" crossOrigin="anonymous" /> : null}
        <div>
          <h1 className="aip-school">THE RISING SCHOOL</h1>
          <div className="aip-tag">Managed by The Synergy Foundation | Sector 12 Savina, Udaipur</div>
        </div>
      </div>
    </div>
    {isKey ? <div className="aip-conf">CONFIDENTIAL — FOR TEACHERS / EXAMINERS ONLY</div> : null}
    <div className="aip-banner">
      {`${paper.examType || ''} Examination`.trim()} — SESSION {paper.session}{isKey ? ' — ANSWER KEY & MARKING SCHEME' : ''}
    </div>
    <div className="aip-grid">
      <div><b>Class:</b> {paper.class}</div>
      <div><b>Subject:</b> {paper.subject}</div>
      <div><b>Time Allowed:</b> {paper.duration}</div>
      <div><b>Max Marks:</b> {paper.maxMarks}</div>
    </div>
    {!isKey ? (
      <div className="aip-instr">
        <b>General Instructions:</b>
        <ol>{GENERAL_INSTRUCTIONS.map((t) => <li key={t}>{t}</li>)}</ol>
      </div>
    ) : null}
  </div>
);

// mode: 'question' (no answers) | 'key' (answers + marking scheme)
function PaperSheet({ paper, mode = 'question', logoSrc, id }) {
  const isKey = mode === 'key';
  let no = 0;
  return (
    <div className="aip-sheet" id={id}>
      <style>{SHEET_CSS}</style>
      <Header paper={paper} isKey={isKey} logoSrc={logoSrc} />
      {paper.sections.filter((s) => s.questions.length).map((s) => (
        <div key={s.name}>
          {s.questions.map((q, i) => {
            no += 1;
            return (
              <div className="aip-block" key={q.qId + i}>
                {i === 0 ? (
                  <>
                    <div className="aip-sec">
                      SECTION {s.name} — {s.title || SECTION_TITLES[s.name] || ''} ({sectionMarks(s)} MARKS)
                    </div>
                    {s.attemptAny > 0 && s.attemptAny < s.questions.length ? (
                      <div className="aip-attempt">Attempt any {s.attemptAny} out of {s.questions.length} questions.</div>
                    ) : null}
                  </>
                ) : null}
                <Question q={q} no={no} mode={paper.languageMode} isKey={isKey} />
              </div>
            );
          })}
        </div>
      ))}
      <div className="aip-foot aip-block">— END OF {isKey ? 'ANSWER KEY' : 'QUESTION PAPER'} —</div>
    </div>
  );
}

export default PaperSheet;
